import PropTypes from 'prop-types'
import PostItem from './PostItem'
import LazyLoad from 'react-lazyload'
import dynamic from 'next/dynamic'
import classNames from 'classnames'
import { useMemo } from 'react'

const SliderCTA = dynamic(() => import('../SliderCTA'))
const PageCategoriesPostsLayout = ({ data, categoryTitle }) => {
  const isArticles = useMemo(
    () => categoryTitle.includes('Articles'),
    [categoryTitle]
  )

  if (!data?.length) return null

  return (
    <div
      data-testid="posts-layout"
      className="mb-6 border-b border-gray-190 lg:mb-0"
    >
      {categoryTitle ? (
        <h1 className="mb-8 text-4xl text-blue-700">{categoryTitle}</h1>
      ) : null}

      <div
        className={classNames('grid grid-cols-1 gap-x-20', {
          'lg:grid-cols-2': isArticles,
        })}
      >
        {data.map((post, i) => {
          if (post.index !== false)
            return (
              <PostItem
                key={`post_${i}`}
                data={{
                  ...post,
                  category: post.category || {},
                }}
                categoryTitle={categoryTitle}
              />
            )
        })}
      </div>
      {isArticles ? (
        <LazyLoad>
          <SliderCTA
            title="Achieve financial control. How much debt do you have?"
            btnLabel="Get your FREE plan now"
            btnMobileLabel="Choose your debt amount"
            phone="800-910-0065"
            phoneClassName="underline underline-offset-4"
            mobileSpecific={true}
          />
        </LazyLoad>
      ) : null}
    </div>
  )
}

PageCategoriesPostsLayout.defaultProps = {
  data: [],
  categoryTitle: '',
}

PageCategoriesPostsLayout.propTypes = {
  data: PropTypes.array,
  categoryTitle: PropTypes.string,
}

export default PageCategoriesPostsLayout
